export const actions = {
  async getFilters(state, data) {
    const filters = new URLSearchParams(data).toString()
    const res = await this.$axios.get('/sommelier/filters?' + filters)
    return res.data
  },
  async getWineCounter(state, data) {
    const filters = new URLSearchParams(data).toString()
    const res = await this.$axios.get('/sommelier/count?' + filters)
    return res.data
  },
  async getHomepageFilters(state, data) {
    const res = await this.$axios.get(
      '/sommelier/page-filters?continent=' +
        data.continent +
        (data.country ? '&country=' + data.country : '')
    )
    return res.data
  },
  async getSommelierPlatesFilters(state, data) {
    const res = await this.$axios.get(
      `/sommelier/food?page=${data.page}&limit=${data.limit}&country=${data.country}`
    )
    return res.data
  },
  async getWines(state, data) {
    const filters = new URLSearchParams(data).toString()
    const res = await this.$axios.get('/sommelier/wines?' + filters)
    return res.data
  },
  async getPage(state) {
    const res = await this.$axios.get('/pages/sommelier')
    return res.data
  },
}
